import { CompanyAssignmentConfigDto } from "@green0meter/api-client";
import { create } from "zustand";

type EntityAssignmentStore = {
  selectedEntities: string[];
  setSelectedEntities: (ids: string[]) => void;
  entitiesAssignments: CompanyAssignmentConfigDto[];
  setEntitiesAssignments: (assignments: CompanyAssignmentConfigDto[]) => void;
};

export const useEntityAssignmentStore = create<EntityAssignmentStore>((set) => ({
  selectedEntities: [],
  setSelectedEntities: (ids: string[]) => set({ selectedEntities: ids }),
  entitiesAssignments: [],
  setEntitiesAssignments: (assignments: CompanyAssignmentConfigDto[]) =>
    set({ entitiesAssignments: assignments }),
}));
